import React, { useEffect, useState } from "react";
import { View, StyleSheet, Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  mapImage: {
    width: 320,
    height: 220,
  },
});

const mapboxBaseUrl = "https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/";
const zoom = 18;
const mapSize = "600x400";

export const MapImagePdf = ({ latitude, longitude }) => {
  const [mapUrl, setMapUrl] = useState("");

  useEffect(() => {
    if (latitude && longitude) {
      const geojsonParam = encodeURIComponent(`{"type":"Point","coordinates":[${longitude},${latitude}]}`);

      const mapboxApiUrl = `${mapboxBaseUrl}geojson(${geojsonParam})/${longitude},${latitude},${zoom}/${mapSize}?access_token=${process.env.REACT_APP_MAPBOX_TOKEN}`;
      setMapUrl(mapboxApiUrl);
    }
  }, [latitude, longitude]);

  return (
    <View>
      <Image src={mapUrl} style={styles.mapImage} />
    </View>
  );
};
